<template>
  <div class="overflow-hidden mt-6 bg-gray-300 py-3 px-4 border-t">
    <div class="float-left relative" style="margin-top:2px;">
      <input type="text"
        class="border border-gray-500 focus:border-gray-600  no-outline p-2 text-sm"
        v-bind:value="query"
        style="width:200px;padding-left:35px;"
        v-on:keyup.enter="queryTyped($event.target.value)"
        placeholder="Search for planner" />

      <div style="position: absolute;top:8px;left:10px;" class="text-gray-700 text-sm">
        <svg width="16" height="16" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#search"/>
        </svg>
      </div>
    </div>

    <div class="float-left text-sm" style="margin:10px 8px 0 30px;">
      <a href="#"
         class="no-underline text-xs uppercase  text-gray-600 hover:underline"
         v-on:click.prevent="reset()">Reset</a>
    </div>
  </div>
</template>

<script>

  import { EventBus } from '@/shared/event-bus'

  export default {

    components : {

    },

    props : {
      params : {
        type    : Object,
        required: false
      }
    },

    computed : {
      query() {
        return this.$route.params.query == null ||
               this.$route.params.query == this.$store.state.emptyQueryIndicator ? null : this.$route.params.query
      }
    },

    watch: {

      '$route' : (newVal, oldVal) => {
        this.query  = newVal.params.query
      },

    },

    methods : {

      queryTyped(value) {
        EventBus.$emit('param-changed', {
          key  : 'query',
          value: value != null && value.length > 0 ? value : this.$store.state.emptyQueryIndicator
        })
      },

      reset() {
        EventBus.$emit('reset-params')
      },
    }

  }
</script>

<style scoped>

</style>
